import React, { Component } from "react";
import ResourcesPage from "../../src/pages/RevampResources/Resources";
import { withRouter } from "next/router";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../src/config/next-seo.config";
import HomeNav from "../../src/pages/Home/HomeNav";
import HomeFooter from "../../src/pages/Home/HomeFooter";

class Resources extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<NextSeo {...seoFunct("resourcesSeo")} />
				{/* <Head>
        			<title>Access all event resources & upskill your knowledge base </title>
        			<meta name="description" content="Missed an event? You can access all the learning resources and update your knowledge database. View videos, read presentations and share information." key="description"/>
					<meta property="og:title" content="Access all event resources & upskill your knowledge base" key="title" />
        			<meta property="og:description" content="Missed an event? You can access all the learning resources and update your knowledge database. View videos, read presentations and share information." key="og:description"/>
      			</Head> */}
				<HomeNav />
				<ResourcesPage />
				<HomeFooter />
			</>
		);
	}
}

export default withRouter(Resources);